module.exports = __webpack_public_path__ + "img/Amborella_trichopoda.78948fb0.jpg";